var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-126.000000, -99.000000)","fillRule":"nonzero"},React.createElement("g",{"transform":"translate(126.000000, 99.000000)"},[React.createElement("g",{"fill":"#FFFFFF","key":0},React.createElement("circle",{"cx":"37.5","cy":"37.5","r":"37.5"})),React.createElement("g",{"transform":"translate(31.000000, 27.000000)","fill":"#0014A2","key":1},React.createElement("polygon",{"points":"0 22 0 0 20.5 11.5"}))]))));
}

PlayButton.defaultProps = {"width":"75px","height":"75px","viewBox":"0 0 75 75","version":"1.1"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
